import { useDispatch, useSelector } from "react-redux";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import {
  changeFirstName,
  changeLastName,
} from "../../../redux/Slices/NameSlice";

const NamesSection = ({ cmsLabels }) => {
  const { firstName, lastName } = useSelector((state) => state.names);
  const { isPostChecked } = useSelector((state) => state.postMail);
  const { isPhoneChecked } = useSelector((state) => state.phone);
  const { isCheckedMobile } = useSelector((state) => state.mobile);
  const { isCheckedFax } = useSelector((state) => state.fax);
  const { isCheckedSMS } = useSelector((state) => state.sms);
  const { isCheckedWhatsApp } = useSelector((state) => state.whatsapp);
  const dispatch = useDispatch();

  return (
    <div className="dds__py-4">
      <div className="dds__row">
        <div className="dds__col--lg-8 dds__col--xl-6">
          <div className="dds__input-text__container dds__row dds__align-items-center">
            <div className="dds__col--md-3">
              <label
                className={
                  isPostChecked ||
                  isPhoneChecked ||
                  isCheckedMobile ||
                  isCheckedFax ||
                  isCheckedSMS
                    ? "required-field"
                    : ""
                }
                id="lblFirstName"
                htmlFor="txtLRFirstName"
              >
                {cmsParser(cms.First_Name, cmsLabels)}
              </label>
            </div>
            <div className="dds__col--md-9">
              <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                <input
                  type="text"
                  className="dds__input-text"
                  maxLength="150"
                  name="txtLRFirstName"
                  id="txtLRFirstName"
                  aria-labelledby="lblFirstName"
                  onChange={(e) => dispatch(changeFirstName(e.target.value))}
                  value={firstName}
                />
                <div
                  id="sample-input-feedback"
                  className="dds__invalid-feedback"
                >
                  Please enter a valid first name.
                </div>
              </div>
            </div>
          </div>
          <div className="dds__input-text__container dds__row dds__align-items-center dds__mt-2">
            <div className="dds__col--md-3">
              <label
                className={
                  isPostChecked ||
                  isPhoneChecked ||
                  isCheckedMobile ||
                  isCheckedFax ||
                  isCheckedSMS
                    ? "required-field"
                    : ""
                }
                id="lblLastName"
                htmlFor="txtLRLastName"
              >
                {cmsParser(cms.Last_Name, cmsLabels)}
              </label>
            </div>
            <div className="dds__col--md-9">
              <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                <input
                  type="text"
                  className="dds__input-text"
                  maxLength="150"
                  name="txtLRLastName"
                  id="txtLRLastName"
                  aria-labelledby="lblLastName"
                  onChange={(e) => dispatch(changeLastName(e.target.value))}
                  value={lastName}
                />
                <div
                  id="sample-input-feedback"
                  className="dds__invalid-feedback"
                >
                  Please enter a valid last name.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NamesSection;
